module.exports = __webpack_public_path__ + "img/5.a1a652f5.jpg";